document.addEventListener('DOMContentLoaded', function () {
    // Bootstrap matching Media Queries
    //To use:
    //      Pass mediaQueries into module function: extranet.Utilities.function(mediaQueries)
    //      In module function:
    //          if(mediaQueries.sm.matches){
    //              code here
    //          }
    var mediaQueries = {
        sm: window.matchMedia('(min-width: 576px)'),
        md: window.matchMedia('(min-width: 768px)'),
        lg: window.matchMedia('(min-width: 992px)'),
        xl: window.matchMedia('(min-width: 1200px)')
    }

    //------------------------------------------------------------------------//
    //  Initialize Lazyloading with support for native lazyload
    //
    //  Defaults to use lazyload plugin, but will fall back to native support 
    //  for browsers with support for the loading="lazy" attribute
    //  (https://caniuse.com/#feat=loading-lazy-attr)
    //------------------------------------------------------------------------//
    var lazyLoadInstance = new LazyLoad({
        elements_selector: ".lazy",
        use_native: true 
    });
    //------------------------------------------------------------------------//
    //  PUBLIC MODULE FUNCTIONS
    //------------------------------------------------------------------------//
    //  Usage Examples: 
    //      site.Utilities.functionName()
    //      site.Utilities.functionName(mediaQueries)
    //------------------------------------------------------------------------//
    site.Utilities.toggleHamburgerIcon(mediaQueries);
    site.Utilities.offcanvasTopPosition(mediaQueries);
    site.Utilities.underlayBelow();
    site.Utilities.overlayAbove();
    site.Utilities.hidePopupBanner();
    site.Utilities.acceptCookieConsent(mediaQueries);
    site.Utilities.cardAnchor();
    site.Accordion.accordionMobile(mediaQueries);
    site.Search.toggleSearchBox();
    site.Search.searchResults();    
    site.CircleGraphic.toggleGraphic();
    site.Countdown.initCountdown();
    site.Forms.replaceFormOnSubmit();
    site.Forms.positionSubmit();
    site.Forms.consentFormText();
    site.Forms.observeForms();
    site.Video.toggleVideo();

    $('img[usemap]').rwdImageMaps(); // jQuery because vanilla doesn't seem to work / Uses Kentico's built-in version
    
    // Check DOM for images loaded via dynamically and update Lazyload instance
    if (lazyLoadInstance) {
        lazyLoadInstance.update();
    }
    
    
    //------------------------------------------------------------------------//
    // WINDOW RESIZE FUNCTIONS
    //------------------------------------------------------------------------//
    window.addEventListener('resize', debounce(function() {
        //------------------------------------------------------------------------//
        //  Public module functions
        //------------------------------------------------------------------------//
        //  Usage Examples: 
        //      site.Utilities.functionName()
        //      site.Utilities.functionName(mediaQueries)
        //------------------------------------------------------------------------//

        site.Utilities.offcanvasTopPosition(mediaQueries);
        site.Utilities.toggleHamburgerIcon(mediaQueries);
        site.Accordion.accordionMobile(mediaQueries);
    }, 200));
}, false);